import { Fragment, ReactNode, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { getSafeRedirectUri } from '@/data/services/login/login-service-utils'
import { getSessionId } from '@/data/services/login/session-id-store'
import { PathConstants } from '../../paths'

// ============================================
// MÓDULO AUTH — TRATAMENTO DE SESSÃO / ANÔNIMO
// ============================================

/**
 * Envolve as rotas públicas (não autenticadas). Se já existe uma sessão, o
 * usuário é uma conta autenticada e é redirecionado para fora das telas de auth
 * em direção ao destino seguro (HOME por padrão). Usuários anônimos renderizam
 * o conteúdo filho.
 */
export const RedirectIfAuthenticated = ({ children }: { children: ReactNode }) => {
  const [searchParams] = useSearchParams()
  const isAuthenticated = !!getSessionId()

  useEffect(() => {
    if (isAuthenticated) {
      const redirectUri = getSafeRedirectUri(searchParams, PathConstants.Routes.HOME.value)
      window.location.replace(redirectUri)
    }
  }, [isAuthenticated, searchParams])

  if (isAuthenticated) return null

  return <Fragment>{children}</Fragment>
}
